import React, { useState } from 'react';
import styled from 'styled-components';
import { useAdminMember } from '../../share/hook/useAdminMember';
import { MemberData } from '../../../shared/dto/EntityRepository';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { formatBytes } from '../../../shared/util/formatBytes';
import { isoInstantToLocalDateInput } from '../../../shared/util/timeInvertor/time';

interface MemberInfoProps {
  data: MemberData;
  isSelected: boolean;
  handleClick: (e: React.MouseEvent<HTMLElement>) => void;
}

const MemberInfo: React.FC<MemberInfoProps> = ({
  data,
  isSelected,
  handleClick
}) => {
  const { activeMember } = useAdminMember();
  const [hovered, setHovered] = useState(false);

  const formatUseage = formatBytes(data.storage.usedSize, true) + " / " + formatBytes(data.storage.maxSize, true);
  const formatLastLogin = data.lastLoginAt ? isoInstantToLocalDateInput(data.lastLoginAt) : '-';

  return (
    <MemberInfoComp
      data-member-id={data.memberId}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <ContentWrapper>
        <TitleBlock $isHover={hovered} $isActive={isSelected}>
          <TitleText>{data.username}</TitleText>
        </TitleBlock>
        <AdminBlockWithVisible
          width={"1.1"}
          value={data.memberType}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={formatLastLogin}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={data.handle}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.2"}
          value={data.exposureLevel}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.3"}
          value={data.status}
          isHover={hovered}
          isActive={isSelected} />
        <AdminBlockWithVisible
          width={"1.5"}
          value={formatUseage}
          isHover={hovered}
          isActive={isSelected} />
        {activeMember && <SpaceBlock />}
      </ContentWrapper>
    </MemberInfoComp>
  );
};


const MemberInfoComp = styled.article`
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  min-height: 40px;
  cursor: pointer;
  
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Body_04};
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const TitleBlock = styled.div<{ $isHover: boolean; $isActive: boolean }>`
  flex: 2.5;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: 10px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : 'none')};
  background-color: ${({ theme, $isHover, $isActive }) =>
    $isActive ? theme.colors.color_Gray_06 : $isHover ? theme.colors.color_Gray_07 : 'transparent'};
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  cursor: pointer;
`;

const TitleText = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: auto;
`;


export default MemberInfo;
